import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, ViewChild } from '@angular/core';
import { NgShuiModule } from '@shui/angular';
import { ChatbotComponent } from '../chatbot/chatbot.component';
import { ChatToggleComponent } from '../chatbot/chat-toggle/chat-toggle.component';

import { WidgetService } from 'src/core/services/widget.service';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-chat-pip-mode',
  imports: [NgShuiModule, ChatbotComponent, ChatToggleComponent, TranslocoModule],
  templateUrl: './chat-pip-mode.component.html',
  styleUrl: './chat-pip-mode.component.css',
  schemas:  [CUSTOM_ELEMENTS_SCHEMA]
})
export class ChatPipModeComponent {
  isMinimized: boolean = false;
  isMaximized: boolean = false;
  isSettled: boolean = false;
  aiPipOpen: boolean = false;
  suggestionsEnabled: boolean = JSON.parse(localStorage.getItem('axisAiSuggestions') ?? 'true');

  @ViewChild('aimenuPip') aimenuPip: ElementRef;

  constructor(private widgetService: WidgetService) {}

  ngOnInit() {
    this.widgetService.$chatPipSize.subscribe(size => {
      if(size === "maximized" && !this.isMaximized && this.widgetService.$workareaSize.value === "fullscreen") {
        this.isMinimized = false;
        this.isMaximized = true;
      }
    });

    this.widgetService.$workareaSize.subscribe(size => {
      if(size === "fullscreen") {
        //this.isMaximized = true;
        this.widgetService.$chatPipSize.next('maximized');
      } else {
        this.isSettled = false;
        this.isMaximized = false;
        this.isMinimized = false;
        this.widgetService.$chatPipSize.next('minimized');
      }
  });
  }

  onMinimize() {
    this.isSettled = false;
    this.isMinimized = true;
    this.isMaximized = false;
    this.aiPipOpen = false;
    this.widgetService.$chatPipSize.next('minimized');
  }

  onMaximize() {
    this.isMinimized = false;
    this.isMaximized = true;
    this.widgetService.$chatPipSize.next('maximized');
  }

  onCardTransitionEnd() {
    if (!this.isMinimized && this.isMaximized) {
      this.isSettled = true;
    }
  }

  expandPip() {
    this.isSettled = false;
    this.isMinimized = false;
    this.isMaximized = false;
    this.widgetService.$workareaSize.next("large");
    this.widgetService.$chatPipSize.next('minimized');
  }

  onAiPipClosed() {
    this.aiPipOpen = false;
  }

  onPipToggleChanged(value: boolean) {
    this.suggestionsEnabled = value;
    localStorage.setItem('axisAiSuggestions', JSON.stringify(value));
    this.aiPipOpen = false;
  }
}
